import React from  'react';
import { Table, Button} from "reactstrap";
import { Link } from 'react-router-dom';
import { ph, subDocument } from '../configData'
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemPanel, AccordionItemHeading } from 'react-accessible-accordion';
import ShareSingleRecord from '../ShareSingleRecord';
// import {ClipLoader} from "react-spinners";
// import { css } from "@emotion/core";
// const override = css`
//   display: block;
//   margin: 0 auto;
//   border-color: red;
// `;

class PrePregnancy extends React.Component {

  state ={
    pregnancyRecord: [],
    successmsg: '',
    errormsg:'',
    loading:false,
    collapse:'',
    modalOpen: false,
    sharedRecordId: null
  }


  toggleCollapse = (id) => {
    if(this.state.collapse === id){
      this.setState({collapse:null})
    }
    else{
      this.setState({collapse: id})
    }
  }

  handleShare = (recordId) => {
    this.setState(prevState => ({
      sharedRecordId: recordId,
      modalOpen: true
    }))
  }

  toggle = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }))
  }



  render(){
    const { pregnancyRecord } = this.props;
    const { modalOpen, sharedRecordId } = this.state;

    return (
      <React.Fragment>
        <Accordion className="accordion">
          {ph.map((week, index) => {
            return (
              <AccordionItem className="accordion__item" key={index}>
                <AccordionItemHeading className="accordion__heading">
                  <AccordionItemButton className="accordion__button">
                    {week['label']}
                    <div className="text-right">
                      <Button
                        className="btn text-right"
                        tag={Link}
                        to={{
                          pathname: "/personalhealthrecord/addpregnancyrecord",
                          state: {
                            type: 3,
                            documentType: week
                          }
                        }}
                      >
                        <i className="fa fa-plus-circle mr-2 text-right"/> Add New Record
                      </Button>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table responsive>
                    <thead className="tableHeader">
                      <tr>
                        <th>S.No</th>
                        <th>Date of Appointment</th>
                        <th>Hospital/Clinic</th>
                        <th>Doctor Name</th>
                        <th>Sub Type of Document</th>
                        <th>Title of Document(s)</th>
                        <th>File Uploaded</th>
                        <th colSpan={2}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.pregnancyRecord[week['value']] && this.props.pregnancyRecord[week['value']].map((record, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{record.documentDetails.appointment.slice(0, 10)}</td>
                          <td>{record.hospitalName}</td>
                          <td>{record.gynecologistName}</td>
                          <td>{subDocument[record['subtypeDocument']]['label']}</td>
                          <td>{record.documentDetails.title}</td>
                          <td>{`${record.documentDetails.files.length} files`}</td>
                          <td>                              
                            <Link to={{ pathname: `/personalhealthrecord/editpregnancyrecord/${record._id}`,
                              state: { type: 3 }
                            }} >
                              <i className="editDiary fa fa-pencil editable-icons" />
                            </Link>
                            <i className="downloadRecord fa fa-download editable-icons" onClick={(e) => this.props.handleDownload(record._id)}/>
                            <i className="shareRecord fa fa-share editable-icons" 
                              onClick={() => this.handleShare(record._id)}
                            />                              
                            <i
                              onClick={() => this.props.handleDelete(week['value'], record._id)}
                              className="deleteDiary fa fa-trash editable-icons"
                            />                                                              
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </AccordionItemPanel>
              </AccordionItem>
            )
          })}
        </Accordion>
        <ShareSingleRecord isOpen={modalOpen} recordId={sharedRecordId} toggle={this.toggle} model="0"/>
      </React.Fragment>
    )
  }
}


export default PrePregnancy



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyRecord/PrePregnancy.js